module.exports = __webpack_public_path__ + "img/mozambique.b2f7373.webp";